"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateThemes = void 0;
var utils_1 = require("../utils");
var generateFile_1 = require("./generateFile");
var getThemeData_1 = require("./getThemeData");
var generateThemes = function (themes, mixin, withDeprecated, withKebabCase) {
    if (mixin === void 0) { mixin = {}; }
    if (withDeprecated === void 0) { withDeprecated = false; }
    var files = [];
    var indexContent = '';
    for (var _i = 0, _a = Object.entries(themes); _i < _a.length; _i++) {
        var _b = _a[_i], fileName = _b[0], themeItem = _b[1];
        var theme = (0, getThemeData_1.getThemeData)(themeItem, mixin, withKebabCase);
        var _c = withDeprecated ? (0, utils_1.getDeprecatedVars)(fileName) : ['', ''], deprecated = _c[0], deprecatedThemeName = _c[1];
        var fileNames = [fileName];
        if (withDeprecated && deprecated) {
            fileNames.push(deprecatedThemeName);
        }
        indexContent += "export { ".concat(fileNames.join(', '), " } from './").concat(fileName, "';\n");
        files.push((0, generateFile_1.generateFile)(fileName, (0, utils_1.attachToRoot)(theme), deprecated));
    }
    files.push({
        file: 'index.ts',
        content: indexContent,
    });
    return files;
};
exports.generateThemes = generateThemes;
//# sourceMappingURL=generateThemes.js.map